import TextRender from 'components/Global/TextRender/TextRender';
import React, { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useStyles } from './CheckboxField.styles';

interface Props {
  infoText: string;
  name: string;
  isRequired?: string;
  error?: string;
  dataAutomation?: string;

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export function CheckboxField(props: Props): JSX.Element {
  const classes = useStyles();
  const methods = useFormContext();
  const { register } = methods ? methods : { register: undefined };

  return (
    <div
      id="checkbox-input"
      className={`${classes.checkbox_container} chkbox-field`}
    >
      {register ? (
        <input
          {...register(props.name, { required: props.isRequired })}
          type="checkbox"
          name={props.name}
          required={props.isRequired ? true : false}
          className={classes.checkbox}
          data-automation={props.name}
          aria-label={props.name}
          onChange={props.onChange}
        />
      ) : (
        <input
          type="checkbox"
          name={props.name}
          required={props.isRequired ? true : false}
          className={classes.checkbox}
          onChange={props.onChange}
        />
      )}
      <p id="checkbox-data" className={'acr-paragraph-8'}>
        <TextRender text={props.infoText} />
      </p>
      {props.error && (
        <p id="error-text" className={`acr-paragraph-8 ${classes.error_text}`}>
          <TextRender text={props.error} />
        </p>
      )}
    </div>
  );
}
